<template>
  <div class="home-dashboard">
    <!-- Header -->
    <div class="dashboard-header">
      <div class="header-left">
        <h1 class="header-title">Hệ Thống Thống Kê & Báo Cáo</h1>
        <p class="header-subtitle">Tổng quan dữ liệu hiện vật, không gian văn hóa, tin tức và thư viện</p>
      </div>
      <div class="header-right">
        <el-form :model="form" :inline="true" size="small">
          <el-form-item prop="dates" class="date-item">
            <el-date-picker
              v-model="form.dates"
              type="daterange"
              range-separator="đến"
              start-placeholder="Ngày bắt đầu"
              end-placeholder="Ngày kết thúc"
              value-format="yyyy-MM-ddT00:00:00"
              format="dd-MM-yyyy"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search">Lọc dữ liệu</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 1. Stats Cards Grid -->
    <div class="cards-grid">
      <artifact-stats-card />
      <cultural-space-count-card />
      <cultural-space-interaction-card />
      <news-interaction-card />
      <library-resource-card />
      <library-interaction-card />
    </div>

    <!-- 2. Large Charts Grid -->
    <div class="charts-grid-large">
      <!-- Donut Chart -->
      <donut-chart />

      <!-- Column Chart -->
      <column-chart />
    </div>

    <!-- 3. Rankings Lists Grid -->
    <div class="rankings-grid">
      <top-artifacts-table />
      <top-spaces-table />
      <top-articles-table />
      <top-videos-table />
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import TopArtifactsTable from './components/TopArtifactsTable.vue'
import TopSpacesTable from './components/TopSpacesTable.vue'
import TopArticlesTable from './components/TopArticlesTable.vue'
import TopVideosTable from './components/TopVideosTable.vue'
import DonutChart from './components/DonutChart.vue'
import ColumnChart from './components/ColumnChart.vue'

import ArtifactStatsCard from './components/ArtifactStatsCard.vue'
import CulturalSpaceCountCard from './components/CulturalSpaceCountCard.vue'
import CulturalSpaceInteractionCard from './components/CulturalSpaceInteractionCard.vue'
import NewsInteractionCard from './components/NewsInteractionCard.vue'
import LibraryResourceCard from './components/LibraryResourceCard.vue'
import LibraryInteractionCard from './components/LibraryInteractionCard.vue'

export default {
  name: 'HomeDashboard',
  components: {
    TopArtifactsTable,
    TopSpacesTable,
    TopArticlesTable,
    TopVideosTable,
    DonutChart,
    ColumnChart,
    ArtifactStatsCard,
    CulturalSpaceCountCard,
    CulturalSpaceInteractionCard,
    NewsInteractionCard,
    LibraryResourceCard,
    LibraryInteractionCard
  },
  data() {
    return {
      form: {
        dates: [dayjs().subtract(30, 'day').format('YYYY-MM-DDT00:00:00'), dayjs().format('YYYY-MM-DDT00:00:00')]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-dashboard {
  background-color: #f7f9fc;
  min-height: calc(100vh - 84px);
  padding: 24px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;

  .dashboard-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    padding: 20px 24px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    margin-bottom: 24px;
    flex-wrap: wrap;
    gap: 16px;

    .header-left {
      .header-title {
        margin: 0 0 4px 0;
        font-size: 20px;
        font-weight: 800;
        color: #2c3e50;
        letter-spacing: -0.5px;
      }
      .header-subtitle {
        margin: 0;
        font-size: 13px;
        color: #7f8c8d;
        font-weight: 500;
      }
    }

    .header-right {
      display: flex;
      align-items: center;

      .el-form {
        display: flex;
        align-items: center;
        gap: 12px;
      }

      .el-form-item {
        margin-bottom: 0;
        margin-right: 0;

        ::v-deep .el-form-item__content {
          display: inline-flex;
          align-items: center;
          line-height: 1;
        }
      }

      ::v-deep .el-button--primary {
        background-color: #8a2be2;
        border-color: #8a2be2;
        border-radius: 8px;
        font-weight: 700;
        font-size: 14px;
        height: 40px;
        padding: 0 24px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 10px rgba(138, 43, 226, 0.1);
        transition: all 0.25s ease;
        box-sizing: border-box;

        &:hover, &:focus {
          background-color: #7315ca;
          border-color: #7315ca;
          box-shadow: 0 4px 14px rgba(138, 43, 226, 0.25);
        }
      }

      ::v-deep .el-date-editor--daterange {
        border-radius: 8px;
        border: 1px solid #e2e8f0;
        padding: 0 16px;
        background-color: #ffffff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.01);
        transition: all 0.25s ease;
        width: 380px;
        height: 40px;
        display: inline-flex;
        align-items: center;
        box-sizing: border-box;

        &.is-active, &:hover {
          border-color: #8a2be2;
          box-shadow: 0 0 0 2px rgba(138, 43, 226, 0.1);
        }

        .el-range-input {
          font-weight: 600;
          color: #2c3e50;
          font-size: 14px;
          height: 100%;
          line-height: 38px;
        }

        .el-range-separator {
          color: #7f8c8d;
          font-weight: 600;
          font-size: 14px;
          width: 10% !important;
          line-height: 38px;
        }

        .el-icon-time {
          color: #8a2be2;
          font-size: 16px;
          line-height: 38px;
        }
      }
    }
  }
}

/* 1. Stats Cards Grid */
.cards-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 24px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.stat-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-top: 4px solid #eaeaea;
  min-height: 125px;
  transition: all 0.3s ease;
  box-sizing: border-box;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  }

  &.purple-top { border-top-color: #8a2be2; }
  &.blue-top { border-top-color: #3498db; }
  &.green-top { border-top-color: #2ecc71; }
  &.red-top { border-top-color: #e74c3c; }
  &.orange-top { border-top-color: #e67e22; }
  &.teal-top { border-top-color: #16a085; }

  .card-header {
    font-size: 12px;
    font-weight: 700;
    color: #8c8c8c;
    margin-bottom: 12px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
  }

  .card-body {
    display: flex;
    align-items: baseline;
    margin-bottom: 8px;

    .value {
      font-size: 26px;
      font-weight: 800;
      color: #2c3e50;
      margin-right: 6px;
    }

    .unit {
      font-size: 14px;
      color: #7f8c8d;
      font-weight: 500;
    }
  }

  .card-footer {
    font-size: 12px;
    font-weight: 500;
    margin-top: 4px;

    &.trend-up {
      color: #27ae60;
      .arrow {
        font-size: 10px;
        margin-right: 2px;
      }
    }

    &.desc {
      color: #95a5a6;
    }
  }

  .interaction-metrics {
    display: flex;
    justify-content: space-between;
    margin-top: auto;
    padding-top: 8px;
    border-top: 1px dashed #f1f1f1;
    gap: 8px;

    .metric-item {
      display: flex;
      flex-direction: column;
      flex: 1;

      .label {
        font-size: 11px;
        color: #7f8c8d;
        font-weight: 600;
        margin-bottom: 4px;
      }

      .num {
        font-size: 14px;
        font-weight: 750;
        color: #2c3e50;

        &.rating {
          color: #f39c12;
        }
      }
    }
  }
}

/* 2. Large Charts Row */
.charts-grid-large {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 20px;
  margin-bottom: 24px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
}

.chart-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  box-sizing: border-box;

  .chart-title {
    font-size: 13px;
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    letter-spacing: 0.3px;

    .bullet {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .purple-bullet { background-color: #8a2be2; }
    .blue-bullet { background-color: #3498db; }
  }
}

.chart-container-large {
  min-height: 400px;
  width: 100%;
  display: block;
}

/* 3. Rankings Lists Grid */
.rankings-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
}

</style>
